<script setup lang="ts">
import { FeatureCreditFormRequest } from '~/components/feature/credit/form-request'
import { ContentBlock } from '~/components/ui/content-block'
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetSelectCreditType } from '~/components/widget/select-credit-type'
import { WidgetReviveAd } from '~/components/widget/revive-ad'

const { t } = useI18n()

const convertibleCurrencies = useCurrencyStore()
  .list.filter((el) => el.is_freely_convertible)
  .map((currency) => ({ code: currency.code, id: currency.id }))

const breadcrumbs = computed(() => [
  { title: t('common.credits'), url: '/credits' },
  { title: t('page.credits.online_request.breadcrumbs.current'), url: '/credits/online-request' }
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
            <WidgetSelectCreditType
              :query-params="{
                'filter[position]': 'sidebar'
              }"
            />
          </aside>
        </template>
        <div>
          <div class="space-y-5" role="main">
            <section>
              <ContentBlock
                variant="white"
                :heading-text="$t('page.credits.online_request.heading')"
                heading-tag="h1"
              >
                <p v-hydrated-html="$t('page.credits.online_request.intro_text')" />
                <p class="font-semibold">
                  {{ $t('page.credits.online_request.partners_note') }}
                </p>

                <FeatureCreditFormRequest :available-currencies="convertibleCurrencies" />

                <p class="font-semibold">
                  {{ $t('page.credits.online_request.service_note') }}
                </p>
              </ContentBlock>
            </section>
          </div>
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
